/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_CommentInputs */



/**
* | output |
* | --- |
* | "Comment" |
*
* @param {Markers_Export_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_comment = /** @type {((inputs?: Markers_Export_CommentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_CommentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commentaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kommentar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Commento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Комментарий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comentario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("评论")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コメント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टिप्पणी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comentário")
	return /** @type {LocalizedString} */ ("Comment")
});